// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 19:47:53

export default {
  "id": "mighty-run",
  "slug": "mighty-run",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/b4742f5c88264e63a88645730c961b1f-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/b4742f5c88264e63a88645730c961b1f/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Mighty Run",
      "description": "Mighty Run is an action-packed platformer where you jump, dodge obstacles, and defeat enemies to progress. Collect gifts along the way and reach the end to grab the diamond, unlocking the next level. Use power-ups, master tricky jumps, and overcome challenges in this thrilling adventure. With smooth controls and exciting gameplay, every level is a test of skill. Can you collect all the rewards and reach the finish line? Play Mighty Run now and prove your skills!",
      "instructions": "Controls for Mighty Run:\n\nLeft Arrow – Move Left\nRight Arrow – Move Right\nUp Arrow – Jump",
      "genres": [
        "Adventure"
      ],
      "tags": [
        "boy",
        "obstacles",
        "platformer",
        "run"
      ]
    },
    "zh-CN": {
      "title": "勇猛疾跑",
      "description": "《勇猛冲刺》是一款充满动作的横版平台游戏，在这里你可以跳跃、躲避障碍和击败敌人以继续前进。沿途收集礼物，到达终点即可抓取钻石，解锁下一级。使用升级道具，掌握技巧性跳跃，并在这场惊险的冒险中克服挑战。凭借流畅的操作和刺激的游戏玩法，每个关卡都是对技能的考验。你能收集所有奖励并抵达终点吗？现在就玩《勇猛冲刺》证明你的实力！",
      "instructions": "游戏操作说明：\n\n左箭头 – 向左移动\n右箭头 – 向右移动\n上箭头 – 跳跃",
      "genres": [
        "冒险"
      ],
      "tags": [
        "小子",
        "障碍",
        "平台跳跃游戏",
        "奔跑"
      ]
    },
    "zh-TW": {
      "title": "強力奔馳",
      "description": "強壯疾走是一款充滿動作的平台遊戲，你必須跳躍、躲避障礙和擊敗敵人來進行進行。沿途中收集禮物，達到終點抓取鑽石，解鎖下一關。使用強化道具，精通複雜的跳躍，並在這場刺激的冒險中克服挑戰。遊戲操控順暢，遊戲過程刺激，每個關卡都是對技能的考驗。你能收集所有獎勵並達到終點線嗎？現在就玩強壯疾走，證明你的技能！",
      "instructions": "控制按鈕設定 for Mighty Run:\n左箭頭 – 向左移動\n右箭頭 – 向右移動\n上箭頭 – 跳躍",
      "genres": [
        "冒險"
      ],
      "tags": [
        "男孩",
        "障礙物",
        "平台遊戲",
        "奔跑"
      ]
    },
    "zh-HK": {
      "title": "強者競速",
      "description": "強力奔馳是一款充滿動作的平台遊戲，你需要在遊戲中跳躍、躲避障礙和擊敗敵人來進行進度。沿路收集禮物，達到終點獲得鑽石，解鎖下一關。使用強化道具，精通複雜的跳躍，並在這場刺激的冒險中克服挑戰。遊戲操控流暢，遊戲過程刺激，每個關卡都是對技能的考驗。你能夠收集所有獎勵並達到終點線嗎？現在就玩強力奔馳，證明你的技能吧！",
      "instructions": "控制設定 for Mighty Run:\n\n左箭頭 – 向左移動\n右箭頭 – 向右移動\n上箭頭 – 跳躍",
      "genres": [
        "冒險"
      ],
      "tags": [
        "小夥仔",
        "障礙物",
        "平台遊戲",
        "跑"
      ]
    },
    "ja": {
      "title": "勇猛の走り",
      "description": "マジティョ・ランは、ジャンプし、障害物を避け、敵を倒して進むアクションパズルゲームです。途中でプレゼントを収集し、最後にダイヤモンドを手に入れ、次のレベルを解除します。パワーアップを使い、難しいジャンプをマスターし、このスリリングなアドベンチャーで挑戦に挑みましょう。スムーズな操作と興味深いゲームプレイで、レベルごとにスキルの試練が待っています。全ての報酬を収集し、フィニッシュラインに達することができますか？今すぐマジティョ・ランをプレイして、あなたのスキルを証明しましょう！",
      "instructions": "Mighty Runのコントロール：\n\n左矢印 – 左に移動\n右矢印 – 右に移動\n上矢印 – 跳躍",
      "genres": [
        "アドベンチャー"
      ],
      "tags": [
        "少年",
        "障害物",
        "パラレルプラットフォームゲーム",
        "走る"
      ]
    },
    "ko": {
      "title": "력사의 달리기",
      "description": "Mighty Run은 점프하고 장애물을 피하며 적을 물리치는 액션 플랫폼 게임입니다. 길에서 선물을 모으고 끝까지 가면 다이아몬드를 잡아 다음 레벨을 해금합니다. 파워업을 사용하고 복잡한 점프를 마스터하고 이 흥미진진한 모험에서 도전을 극복하세요. 원활한 조종과 흥미로운 게임플레이로 각 레벨은 기술의 시험입니다. 모든 보상을 모으고 종료선에 도달할 수 있을까요? 지금 Mighty Run을 플레이하고 자신의 기술을 증명하세요!",
      "instructions": "마이티 런 제어 방법:\n\n왼쪽 방향키 – 왼쪽으로 이동\n오른쪽 방향키 – 오른쪽으로 이동\n위 방향키 – 점프",
      "genres": [
        "모험"
      ],
      "tags": [
        "아저씨",
        "장애물",
        "플랫폼게임",
        "달리기"
      ]
    },
    "fr": {
      "title": "Course des Titans",
      "description": "Mighty Run est un plate-formiste full d'action où tu sautes, esquives les obstacles et bats les ennemis pour progresser. Collecte des cadeaux en route et atteins la fin pour saisir le diamant, débloquant ainsi le niveau suivant. Utilise des power-ups, maitrise des sauts délicats et surmonte les défis dans cette aventure palpitante. Avec des contrôles fluides et un gameplay excitant, chaque niveau est un test de compétences. Peux-tu collecter tous les récompenses et atteindre la ligne d'arrivée ? Joue à Mighty Run maintenant et prouve tes compétences !",
      "instructions": "Contrôles pour Mighty Run :\n\nFlèche de gauche – Déplacer vers la gauche\nFlèche de droite – Déplacer vers la droite\nFlèche du haut – Sauter",
      "genres": [
        "Aventure"
      ],
      "tags": [
        "garçon",
        "obstacles",
        "plate-forme",
        "courir"
      ]
    }
  }
};
